import { useTranslation } from 'react-i18next'
import useLockedBalance from '../../hooks/useLockedBalance'
import BaseBalanceCard from './BaseBalanceCard'

const LockedBalanceCard = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetCard' })

  const {
    goldBalanceInUsd,
    rwaBalanceInUsd,
    cryptoBalanceInUsd,
    totalBalanceInUsd,
    loading,
  } = useLockedBalance()

  return (
    <BaseBalanceCard
      loading={loading}
      title={t('locked')}
      goldBalanceInUsd={goldBalanceInUsd}
      rwaBalanceInUsd={rwaBalanceInUsd}
      cryptoBalanceInUsd={cryptoBalanceInUsd}
      totalBalanceInUsd={totalBalanceInUsd}
    />
  )
}

export default LockedBalanceCard
